// src/hooks/usePageContent.js
import { useState } from 'react';
import { checkoutPayment } from '../services/paymentService';

const useCheckout = () => {
    const [status, setStatus] = useState('idle'); // idle | loading | done | error
    const [error, setError] = useState('');
    const [redirect, setRedirect] = useState([]);
    const [data, setData] = useState({});

    const checkout = async (payment) => {
        setStatus('loading');
        setError('');

        try {
            const response = await checkoutPayment(payment);

            if (response?.status !== 'Error') {
                setRedirect(response.redirect); // depending on API shape
                setData(response.data);
                setStatus('done');
            } else {
                setStatus('error');
                setError(response?.message || response || 'Something went wrong');
            }
        } catch (err) {
            setStatus('error');
            setError(err?.message || err || 'Something went wrong');
        }
    };

    const resetStatus = () => {
        setStatus('idle');
        setError('');
    };

    return {
        checkout,
        data,
        redirect,
        status,
        error,
        resetStatus
    };
};

export default useCheckout;
